import {
  ORDER_METHODS,
  SMART_PRICING_MODIFIER_TYPE,
  SMART_PRICING_RESOURCE_TYPE,
} from '../../../../../services/exports/Constants';

export default {
  title: {
    [SMART_PRICING_RESOURCE_TYPE.company]: '{{name}} globale slimme prijsregel',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: '{{name}} master slimme prijsregel',
    [SMART_PRICING_RESOURCE_TYPE.menu]: '{{name}} menu slimme prijsregel',
    [SMART_PRICING_RESOURCE_TYPE.category]: '{{name}} categorie slimme prijsregel',
    [SMART_PRICING_RESOURCE_TYPE.product]: '{{name}} product slimme prijsregel',
    [SMART_PRICING_RESOURCE_TYPE.modifier_group]: '{{name}} modifier-groep slimme prijsregel',
    [SMART_PRICING_RESOURCE_TYPE.modifier]: '{{name}} modifier slimme prijsregel',
  },
  labels: {
    new: 'Nieuw',
    base_price: '{{name}} basisprijs: {{value}}',
  },
  form: {
    resource: {
      [SMART_PRICING_RESOURCE_TYPE.menu]: 'Menu',
      [SMART_PRICING_RESOURCE_TYPE.category]: 'Categorie',
      [SMART_PRICING_RESOURCE_TYPE.product]: 'Product',
      [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Modifier-groep',
      [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Modifier',
      placeholder: 'Selecteer {{resource}}',
    },
    order_methods: {
      label: 'Bestelmethoden',
      placeholder: 'Selecteer bestelmethoden waarop de regel van toepassing is',
      options: {
        [ORDER_METHODS.pickup]: 'Afhalen',
        [ORDER_METHODS.delivery]: 'Bezorging',
        [ORDER_METHODS.on_site]: 'Tafelbestellen',
      },
    },
    modifier_type: {
      label: 'Type prijswijziging',
      placeholder: 'Selecteer type prijswijziging',
      disabled_tooltip:
        'Absoluut is niet beschikbaar voor menubrede regels, omdat het de prijs van elk item zou overschrijven.',
      tooltip: {
        title: 'Het type wijziging bepaalt hoe prijzen worden aangepast',
        description: {
          [SMART_PRICING_MODIFIER_TYPE.absolute]:
            'Absoluut: overschrijft de resourceprijs naar de opgegeven wijzigingswaarde',
          [SMART_PRICING_MODIFIER_TYPE.percentage]:
            'Percentage: telt het opgegeven percentage op bij of trekt het af van de basisprijs van de resource, afhankelijk van het teken van de wijzigingswaarde',
          [SMART_PRICING_MODIFIER_TYPE.fixed_value]:
            'Vaste waarde: telt de opgegeven vaste waarde op bij of trekt ze af van de basisprijs, afhankelijk van het teken van de wijzigingswaarde',
        },
      },
      options: {
        [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Absoluut',
        [SMART_PRICING_MODIFIER_TYPE.percentage]: 'Percentage',
        [SMART_PRICING_MODIFIER_TYPE.fixed_value]: 'Vaste waarde',
      },
    },
    modifier_value: {
      label: 'Waarde prijswijziging',
    },
    round: {
      label: 'Resulterende prijs afronden',
      tooltip:
        'Rondt de resulterende prijs naar boven af op 10 (bijv. 14,91; 14,93; 14,99 worden 15,00). Vooral nuttig voor percentageregels',
    },
    is_visible: {
      label: 'Aan klant tonen als aanbieding',
    },
    name: {
      label: 'Naam',
      placeholder: 'Voer een klantvriendelijke naam in',
      default: '{{value}} korting op {{resource}}',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_load_data: 'Laden van gegevens mislukt',
    failed_to_save_changes: 'Opslaan van wijzigingen mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
